import React from "react";
import classnames from "classnames";
import { compose, mapProps, pure } from "recompose";
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser";
import defaultTransforms from "./MagentoWysiwyg/transforms";
import defaultShortcodes from "./MagentoWysiwyg/shortcodes";
import logHandler from "web/core/logs/logHandler";

export default (params) => {
  var richTextPropName, transforms, shortcodes;

  if (typeof params === "string") {
    richTextPropName = params;
    transforms = defaultTransforms;
    shortcodes = defaultShortcodes;

    if (process.env.NODE_ENV === "development") {
      console.warn(
        `Deprecation warning: EnhanceWysiwyg's first parameter should now be an object but was used with "${params}". Please use {richTextPropName: "${params}"} instead. The string params will be removed in 1.0.0.`
      );
    }
  } else {
    richTextPropName =
      params && params.richTextPropName ? params.richTextPropName : "content";

    if (
      process.env.NODE_ENV === "development" &&
      !params &&
      !params.transforms
    ) {
      console.warn(
        `Deprecation warning: "transforms" option should be defined when using "EnhanceWysiwyg". The current default is MagentoWysiwyg's transforms but it will be removed in 1.0.0. Please refer to https://developers.front-commerce.com/docs/reference/wysiwyg.html.`
      );
    }
    transforms =
      params && params.transforms ? params.transforms : defaultTransforms;

    if (
      process.env.NODE_ENV === "development" &&
      !params &&
      !params.shortcodes
    ) {
      console.warn(
        `"shortcodes" option should be defined when using "EnhanceWysiwyg". The current default is MagentoWysiwyg's shortcodes but it will be removed in 1.0.0. Please refer to https://developers.front-commerce.com/docs/reference/wysiwyg.html.`
      );
    }
    shortcodes =
      params && params.shortcodes ? params.shortcodes : defaultShortcodes;
  }

  const transform = (node, index) => {
    const component = transforms.reduce((result, transformItem) => {
      if (result) {
        return result;
      }

      try {
        return transformItem(node, (node, index) => {
          return (
            transform(node, index) ||
            convertNodeToElement(node, index, transform)
          );
        });
      } catch (e) {
        logHandler.getLogger().error(e);
        return null;
      }
    }, null);

    if (component) {
      return React.cloneElement(component, { key: index });
    }
  };

  return compose(
    pure,
    mapProps((props) => {
      const children = ReactHtmlParser(
        shortcodes(props).reduce(
          (html, shortcode) =>
            html.replace(shortcode.regex, shortcode.replacement),
          props[richTextPropName] || ""
        ),
        {
          transform,
        }
      );

      return {
        ...props,
        className: classnames("wysiwyg", props.className),
        children,
      };
    })
  );
};
